import { get } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { common, formData, payment, teams, voucher } from '../../../../constants/actions'
import {
  getFormMessages,
  getFormSettings,
  getFormType,
  getOrderId,
  getOrgAddress,
  getPaymentData,
  getPaymentType,
  getRoktConfiguration,
  getTeamCode,
  getTeamLogo,
  getUser,
} from '../../../../selectors'
import Success from './component'

const mapStateToProps = state => ({
  user: getUser(state),
  orderId: getOrderId(state),
  paymentType: getPaymentType(state),
  paymentData: getPaymentData(state),
  formType: getFormType(state),
  paymentMethod: get(state, 'payment.paymentMethod'),
  formSettings: getFormSettings(state),
  confirmationMessages: getFormMessages(state).confirmation,
  teamSuccessMessages: getFormMessages(state).teamSuccess,
  orgAddress: getOrgAddress(state),
  roktConfiguration: getRoktConfiguration(state),
  registeredTeam: get(state, 'formData.team'),
  registrations: get(state, 'formData.registrations'),
  teamCode: getTeamCode(state),
  teamLogo: getTeamLogo(state),
  orderStatus: get(state, 'payment.orderStatus'),
})

export default withRouter(
  connect(mapStateToProps, {
    resetForm: formData.resetForm,
    resetVoucher: voucher.resetVoucher,
    sendRegistrationCode: teams.sendEmailTeamRego,
    getTeamLogo: teams.getTeamLogo,
    getOrderStatus: payment.getOrderStatus,
    startTimer: common.setStartTimer,
  })(Success)
)
